import axios from "axios"
import { CollectionQuery } from "../../../models/collection.model"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { SALE_ENDPOINT } from "../sale.endpoint"

export const exportSales = async (query: CollectionQuery) => {
  try {
    const url = `${SALE_ENDPOINT.export}?${collectionQueryBuilder(query)}`

    const response = await axios.get(url, {
      responseType: "arraybuffer",
       headers: {
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`,
      }
    })

    return response.data // This will be the ArrayBuffer
  } catch (error) {
    console.error("Error fetching export pretrips:", error)
    throw error // Re-throw the error for the caller to handle
  }
}
